import type { ModelDefinition } from "@/models.js";

export const microsoftModels = [] as const satisfies ModelDefinition[];
